import React from "react";
import { Grid2, Box } from "@mui/material";
import StaffCard from "./components/StaffCard";

const staffMembers = [
  {
    id: 1,
    name: "مهدی صانعی",
    role: "مربی",
    joinDate: "22",
    score: "95",
    profilePic: "",
  },
  {
    id: 2,
    name: "احمدرضا رضایی",
    role: "مربی",
    joinDate: "24",
    score: "98",
    profilePic: "",
  },
];

const staffMembers2 = [
  {
    id: 1,
    name: "سید علی فیاض",
    role: "دروازه بان",
    joinDate: "26",
    score: "96",
    profilePic: "",
  },
  {
    id: 2,
    name: "علیرضا نصیری نژاد",
    role: "دفاع",
    joinDate: "21",
    score: "97",
    profilePic: "",
  },
  {
    id: 3,
    name: "عباسعلی اسدی تیرتاشی",
    role: "دفاع",
    joinDate: "23",
    score: "93",
    profilePic: "",
  },
  {
    id: 4,
    name: "پویا قاسمی",
    role: "هافبک میانی",
    joinDate: "25",
    score: "99",
    profilePic: "",
  },
  {
    id: 5,
    name: "علیرضا مختارابادی",
    role: "هافبک نگه‌دارنده",
    joinDate: "21",
    score: "100",
    profilePic: "",
  },
  {
    id: 6,
    name: "علی زینل وند",
    role: "نوک",
    joinDate: "22",
    score: "89",
    profilePic: "",
  },
];

export default function TechStaff() {
  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        padding: 2,
      }}
    >
      <Grid2 container spacing={1}>
        {/* Title */}
        <Grid2 size={12}>
          <h2>کادر فنی</h2>
        </Grid2>

        {/* Cards */}
        {staffMembers.map((staff) => (
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={staff.id}>
            <StaffCard
              name={staff.name}
              role={staff.role}
              joinDate={staff.joinDate}
              profilePic={staff.profilePic}
              score={staff.score}
            />
          </Grid2>
        ))}

        {/* Title */}
        <Grid2 size={12}>
          <h2>بازیکنان</h2>
        </Grid2>
        {/* Cards */}
        {staffMembers2.map((staff) => (
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={staff.id}>
            <StaffCard
              name={staff.name}
              role={staff.role}
              joinDate={staff.joinDate}
              profilePic={staff.profilePic}
              score={staff.score}
            />
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
}
